<script setup lang="ts">
import {ref} from "vue";
import {SectionService} from "@/api/api.ts";
import {ElNotification, genFileId, UploadInstance, UploadRawFile} from "element-plus";

const visible = ref<boolean>(false);

const upload = ref<UploadInstance>()
let courseId = 0;
const excelFile = ref<File>();
const excelName = ref<string>("");

const hide = () => {
  visible.value = false;
  excelFile.value = undefined;
  excelName.value = "";
};

const show = (_courseId: number) => {
  console.log("show")
  courseId = _courseId;
  visible.value = true;
};

const importFile = (e: any) => {
  excelName.value = e.file.name;
  excelFile.value = e.file;
};

const emit = defineEmits(["onAddSuccess"]);

const onSubmit = async () => {
  if (!excelFile.value) {
    return ElNotification.error({
      message: "请选择文件",
    })
  }
  try {
    const formData = new FormData();
    formData.append("file", excelFile.value as Blob);
    formData.append("course_id", courseId.toString());
    const res = await SectionService.batchAddRecordSection(formData)
    if (res.data.code === 200) {
      ElNotification.success({
        title: "批量添加成功",
        message: res.data.msg,
      })
      hide()
      emit("onAddSuccess")
    } else {
      ElNotification.error({
        message: res.data.msg,
      })
    }
  } catch (e) {
    console.warn(e);
  }
};

const onExceed = (files: any) => {
  upload.value!.clearFiles()
  const file = files[0] as UploadRawFile
  file.uid = genFileId()
  upload.value!.handleStart(file)
  excelName.value = file.name;
  excelFile.value = file;
}

defineExpose({hide, show});
</script>

<template>
  <el-dialog v-model="visible" title="批量添加章节(录播课)" align-center>
    <el-upload
        ref="upload"
        :multiple="false"
        :show-file-list="true"
        :http-request="importFile"
        :on-exceed="onExceed"
        :limit="1"
        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
      <template #trigger>
        <el-button type="primary">选择文件</el-button>
      </template>
    </el-upload>
    <a href="https://view.bioquan.com/%E5%BD%95%E6%92%AD%E8%AF%BE%E7%AB%A0%E8%8A%82%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx">下载模板文件</a>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="hide">取消</el-button>
        <el-button type="primary" @click="onSubmit">
          确认上传
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>
</style>
